document.querySelectorAll('[data-hover-menu="true"]').forEach((navigation) => {
  if (
    !window.matchMedia(
      "(hover: hover) and (pointer: fine) and (min-width: 990px)",
    ).matches
  )
    return;

  const menus = navigation.querySelectorAll("header-menu");
  const closeTimers = new WeakMap();
  let lastOpenedIndex = -1;

  const openMenu = (details, summary, menuIndex) => {
    clearTimeout(closeTimers.get(details));
    details.classList.remove("is-closing");

    const direction =
      lastOpenedIndex === -1 || menuIndex >= lastOpenedIndex ? "right" : "left";
    details.classList.toggle("from-left", direction === "left");
    details.classList.toggle("from-right", direction === "right");
    lastOpenedIndex = menuIndex;

    if (details.hasAttribute("open")) {
      summary.setAttribute("aria-expanded", "true");
      return;
    }

    details.classList.add("is-opening");
    details.setAttribute("open", "");
    summary.setAttribute("aria-expanded", "true");

    requestAnimationFrame(() => {
      requestAnimationFrame(() => details.classList.remove("is-opening"));
    });
  };

  const closeMenu = (details, summary, delay = 0) => {
    if (!details.hasAttribute("open")) return;

    clearTimeout(closeTimers.get(details));

    if (delay) {
      const closeTimer = setTimeout(() => closeMenu(details, summary), delay);
      closeTimers.set(details, closeTimer);
      return;
    }

    details.classList.remove("is-opening");
    details.classList.add("is-closing");
    summary.setAttribute("aria-expanded", "false");

    const closeTimer = setTimeout(() => {
      details.removeAttribute("open");
      details.classList.remove("is-closing");
    }, 220);

    closeTimers.set(details, closeTimer);
  };

  menus.forEach((menu, menuIndex) => {
    const details = menu.querySelector("details");
    const summary = details?.querySelector(":scope > summary");
    const content = details?.querySelector(":scope > .mega-menu__content");

    if (!details || !summary || !content) return;

    summary.addEventListener("click", (event) => {
      if (event.detail > 0) event.preventDefault();
    });

    menu.addEventListener("pointerenter", () => {
      menus.forEach((otherMenu) => {
        if (otherMenu === menu) return;

        const otherDetails = otherMenu.querySelector("details");
        const otherSummary = otherDetails?.querySelector(":scope > summary");
        if (otherDetails && otherSummary) closeMenu(otherDetails, otherSummary);
      });

      openMenu(details, summary, menuIndex);
    });

    content.addEventListener("pointerenter", () => {
      clearTimeout(closeTimers.get(details));
      details.classList.remove("is-closing");
    });

    content.addEventListener("pointerleave", () => {
      closeMenu(details, summary, 140);
    });

    menu.addEventListener("pointerleave", () => {
      if (
        menu.contains(document.activeElement) &&
        document.activeElement.matches(":focus-visible")
      )
        return;

      closeMenu(details, summary, 140);
    });
  });
});
